var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center"},[_c('v-overlay',[_c('v-progress-circular',{attrs:{"color":"blue","indeterminate":"","size":70,"width":7}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }